import { PageZoomControl } from '@domain-group/suit-theme'

import type {
  UsePublicationBookingPlannerPayload,
} from '@components/PublicationBookingPlanner/hooks/usePublicationBookingPlanner'

interface ZoomControlProps {
  bookingPlannerPayload: UsePublicationBookingPlannerPayload,
}

const ZoomControl = (props: ZoomControlProps) => {
  const {
    bookingPlannerPayload: {
      availableZooms,
      callbacks: {
        performZoomAction,
        selectZoomValue,
        zoomToBestFit,
      },
      zoom,
    },
  } = props

  return (
    <PageZoomControl
      availableZooms={availableZooms}
      callbacks={{
        performZoomAction,
        selectZoomValue,
        zoomToBestFit,
      }}
      disableModal
      selectedZoom={zoom}
      showBestFitOption
      style={{
        position: 'fixed',
        right: 16,
        bottom: 16,
        zIndex: 10,
      }}
    />
  )
}

export default ZoomControl
